import {ResizeSensor} from 'css-element-queries';

class NavDesktop {

    constructor() {
        this.container = document.querySelector('.nav-desktop');
        this.linksContainer = this.container.querySelector('.link-section');
        this.logo = this.container.querySelector('.home-link');
        this.searchContainer = this.container.querySelector('.search-box');
        this.searchInput = this.searchContainer.querySelector('input');
        this.searchClearButton = this.searchContainer.querySelector('.close-button');
        this.contractorSubmenuLink = this.container.querySelector('.search-section #contractor-submenu');

        this.isSticky = this.container.dataset.isSticky === "true";
        this.hasAnnouncement = this.container.dataset.hasAnnouncement === "true";

        this.registerListeners();
        this.initStickiness();
        this.initContractorMenu();
        this.findSelectedTab();
    }

    initContractorMenu() {

    }

    findSelectedTab() {
      var currentUrl = window.location;
      var selectedLink = document.querySelector('#desktop-nav a[href="' + currentUrl + '"]');
      
      if(!selectedLink) {
        return;
      }

      var currentTab = selectedLink.closest('.nav-header-link');

      if(currentTab) {
        currentTab.classList.add('active');
      }
    }

    static get ANNOUNCEMENT_HEIGHT() {
        return document.querySelector('section.announcement').getBoundingClientRect().height;
    }

    initStickiness() {
        if(this.isSticky) {
            window.addEventListener('resize', () => this.handleResize(this));
            document.addEventListener('scroll', e => this.shouldNavStick(e, this));
        } else if(!this.hasAnnouncement) {
            this.container.querySelectorAll('.menu').forEach((menu) => {
                menu.style.marginTop = 0;
            });
        }
    }

    registerListeners() {
        this.searchResizeSensor = new ResizeSensor(this.searchContainer, () => this.handleSearchboxExpansion(this));
        this.searchInput.addEventListener('input', (e) => this.handleSearchInput(e, this));
        this.searchClearButton.addEventListener('click', () => this.handleClearSearchClick(this));
        this.searchContainer.addEventListener('click', () => this.handleSearchIconClicked(this));
        this.searchContainer.addEventListener('focusout', (e) => this.handleSearchInputBlur(e, this));
        this.searchInput.addEventListener('focusout', (e) => this.handleSearchInputBlur(e, this));
        this.searchInput.addEventListener('focusin', (e) => this.handleSearchInput(e, this));
    }

    handleSearchboxExpansion(instance) {
        if(instance.searchInput.clientWidth > 40) {
            instance.linksContainer.classList.add('hidden');
        } else {
            instance.linksContainer.classList.remove('hidden');
        }
    }

    handleResize(instance) {
        instance.adjustWidth();
    }

    adjustWidth() {
        this.container.style.width = `${document.querySelector('header.header').getBoundingClientRect().width}px`;
    }

    shouldNavStick(e, instance) {
        if(instance.isSticky) {
            if(NavDesktop.ANNOUNCEMENT_HEIGHT - window.scrollY <= 0) {
                instance.adjustWidth();
                instance.container.classList.add('sticky');
            } else {
                instance.container.classList.remove('sticky');
            }
        }
    }

    toggleSearchClearButton(isVisible) {
        this.searchClearButton.style.visibility = isVisible ? 'visible' : 'hidden';
    }

    handleSearchInput(e, instance) {
        instance.toggleSearchClearButton(e.target.value.length > 0);
    }

    handleClearSearchClick(instance) {
        instance.searchInput.value = "";
        instance.handleSearchInput(instance.searchInput, instance);
    }

    handleSearchIconClicked(instance) {
        instance.searchContainer.addEventListener('transitionend', () => {
            instance.searchInput.focus();
            instance.searchContainer.removeEventListener('transitionend', this);
        });

        instance.searchContainer.classList.add('expanded');
    }

    handleSearchInputBlur(e, instance) {
        const leavingParent = !instance.searchContainer.contains(e.relatedTarget);

        if (leavingParent) {
            instance.toggleSearchClearButton(false);
            instance.searchContainer.classList.remove('expanded');
        }

    }
}

document.addEventListener('DOMContentLoaded', () => {
    window.navDesktop = new NavDesktop();
})